export type OnLoadEventPayload = {
  url: string
}

export type GeetestCaptchaResult = {
  pass_token: string
  lot_number: string
  gen_time: string
  captcha_output: string
  captcha_id: string
}

export type CaptchaSuccessEventPayload = {
  result: GeetestCaptchaResult
}

export type CaptchaErrorEventPayload = {
  code: number
  message: string
}

export type GeetestModuleEvents = {
  onChange: (params: ChangeEventPayload) => void
  onCaptchaSuccess: (params: CaptchaSuccessEventPayload) => void
  onCaptchaError: (params: CaptchaErrorEventPayload) => void
}

export type ChangeEventPayload = {
  value: string
}

export type GeeTest = GeeTestEvents & {
  appendTo: (element: HTMLElement | string) => void
  getValidate: () => GeetestCaptchaResult
  reset: () => void
  showCaptcha: () => void
  destroy: () => void
}

export type GeeTestEvents = {
  onReady: (callback: OnReadyFn) => void
  onNextReady: (callback: OnNextReadyFn) => void
  onSuccess: (callback: OnSuccessFn) => void
  onFail: (callback: OnFailFn) => void
  onError: (callback: OnErrorFn) => void
  onClose: (callback: OnCloseFn) => void
}

export type OnReadyFn = () => void
export type OnNextReadyFn = () => void
export type OnSuccessFn = (result: GeetestCaptchaResult | undefined) => void
export type OnFailFn = (error: GeeTestError) => void
export type OnErrorFn = (error: GeeTestError) => void
export type OnCloseFn = () => void

export type GeeTestError = {
  code: string
  msg: string
  desc: {
    detail: string
  }
}
